import MenuItem from '../../../core/menu/item.gjs';

const METADATA = {
  component: 'Spds::Action::Button::Split::MenuItem',
  description: 'Menu item component for split buttons',
  name: 'Split Menu Item',
};

export default class SpdsActionButtonSplitMenuItem extends MenuItem {
  static metadata = MenuItem.setMetadata(METADATA);
  variantClass = 'spds-action-button-split-menu-item';

  onClick = (...args) => {
    super.onClick(...args);

    this.args.toggleOpenState();
  };
}

export const ACTION_BUTTON_SPLIT_MENU_ITEM_METADATA = SpdsActionButtonSplitMenuItem.metadata;
